import { CheckCircle, Clear, Error, Info, Warning } from '@mui/icons-material';
import Button from '@mui/material/Button';
import SnackbarContent from '@mui/material/SnackbarContent';
import { alpha } from '@mui/material/styles';
import { withStyles } from '@mui/styles';

const styles = (theme) => ({
    root: {
        background: 'linear-gradient(60deg, ' + theme?.palette?.primary?.lighter + ', ' + theme?.palette?.primary?.darker + ')',
        color: '#fff',
        marginBottom: 10,
        whiteSpace: 'pre-wrap',
    },
    shadowRoot: {
        boxShadow:
            '0px 11px 15px -7px ' +
            alpha(theme?.palette?.primary?.dark, 0.1) +
            ', 0px 24px 38px 3px ' +
            alpha(theme?.palette?.primary?.dark, 0.1) +
            ', 0px 9px 46px 8px ' +
            alpha(theme?.palette?.primary?.dark, 0.1) +
            '',
    },
    error: {
        background: 'linear-gradient(60deg, ' + theme?.palette?.error?.lighter + ', ' + theme?.palette?.error?.darker + ')',
        color: '#fff',
        marginBottom: 10,
        whiteSpace: 'pre-wrap',
    },
    shadowError: {
        boxShadow:
            '0px 11px 15px -7px ' +
            alpha(theme?.palette?.error?.dark, 0.1) +
            ', 0px 24px 38px 3px ' +
            alpha(theme?.palette?.error?.dark, 0.1) +
            ', 0px 9px 46px 8px ' +
            alpha(theme?.palette?.error?.dark, 0.1) +
            '',
    },
    warning: {
        background: 'linear-gradient(60deg, ' + theme?.palette?.warning?.lighter + ', ' + theme?.palette?.warning?.darker + ')',
        color: '#fff',
        marginBottom: 10,
        whiteSpace: 'pre-wrap',
    },
    shadowWarning: {
        boxShadow:
            '0px 11px 15px -7px ' +
            alpha(theme?.palette?.warning?.dark, 0.1) +
            ', 0px 24px 38px 3px ' +
            alpha(theme?.palette?.warning?.dark, 0.1) +
            ', 0px 9px 46px 8px ' +
            alpha(theme?.palette?.warning?.dark, 0.1) +
            '',
    },
    success: {
        background: 'linear-gradient(60deg, ' + theme?.palette?.success?.lighter + ', ' + theme?.palette?.success?.darker + ')',
        color: '#fff',
        marginBottom: 10,
        whiteSpace: 'pre-wrap',
    },
    shadowSuccess: {
        boxShadow:
            '0px 11px 15px -7px ' +
            alpha(theme?.palette?.success?.dark, 0.1) +
            ', 0px 24px 38px 3px ' +
            alpha(theme?.palette?.success?.dark, 0.1) +
            ', 0px 9px 46px 8px ' +
            alpha(theme?.palette?.success?.dark, 0.1) +
            '',
    },
    info: {
        background: 'linear-gradient(60deg, ' + theme?.palette?.info?.lighter + ', ' + theme?.palette?.info?.darker + ')',
        color: '#fff',
        marginBottom: 10,
        whiteSpace: 'pre-wrap',
    },
    shadowInfo: {
        boxShadow:
            '0px 11px 15px -7px ' +
            alpha(theme?.palette?.info?.dark, 0.1) +
            ', 0px 24px 38px 3px ' +
            alpha(theme?.palette?.info?.dark, 0.1) +
            ', 0px 9px 46px 8px ' +
            alpha(theme?.palette?.info?.dark, 0.1) +
            '',
    },
});

type SnackbarProps = {
    abort?: any;
    bigfat?: boolean;
    classes?: any;
    error?: boolean;
    first?: any;
    firstIcon?: any;
    firstText?: string;
    info?: boolean;
    message?: any;
    second?: any;
    secondIcon?: any;
    secondText?: string;
    success?: boolean;
    warning?: boolean;
};

function Snackbar(moduleProps: SnackbarProps) {
    const props = {
        ...moduleProps,
    };

    const { classes } = props;
    const paperStyle = props.error ? classes.error : props.warning ? classes.warning : props.success ? classes.success : props.info ? classes.info : classes.root;
    return (
        <SnackbarContent
            classes={{ root: paperStyle }}
            message={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {props.error || props.warning || props.success || props.info ? (
                        <div style={{ lineHeight: 1, marginRight: 8 }}>
                            {props.error ? <Error /> : props.warning ? <Warning /> : props.success ? <CheckCircle /> : props.info ? <Info /> : undefined}
                        </div>
                    ) : undefined}
                    <div style={{ fontSize: props.bigfat ? '1.5em' : undefined, fontWeight: props.bigfat ? 700 : undefined }}>{props.message}</div>
                </div>
            }
            action={
                <>
                    {props.abort ? (
                        <Button onClick={props.abort} startIcon={<Clear data-testid="abort" />} sx={{ color: 'common.white' }}>
                            Ausblenden
                        </Button>
                    ) : undefined}
                    {props.first ? (
                        <Button onClick={props.first} startIcon={<div data-testid="first">{props.firstIcon}</div>} sx={{ color: 'common.white' }}>
                            {props.firstText}
                        </Button>
                    ) : undefined}
                    {props.second ? (
                        <Button onClick={props.second} startIcon={<div data-testid="second">{props.secondIcon}</div>} sx={{ color: 'common.white' }}>
                            {props.secondText}
                        </Button>
                    ) : undefined}
                </>
            }
        />
    );
}

export default withStyles(styles)(Snackbar);
